<div class="disclaimer">
  <span v-html="agbText"></span> <span v-html="privacyText"></span>
</div>
